import MagazineTabs from "@scripts/magazine/MagazineTabs";

class AuthorList {
  private el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
  }

  public init() {
    new MagazineTabs(this.el);
  }
}

const components = {
  "author-list": AuthorList
};

export function initComponents(root = document) {
  Object.entries(components).forEach(([name, Component]) => {
    root.querySelectorAll<HTMLElement>(`[data-component="${name}"]`).forEach(el => {
      new Component(el).init();
    });
  });
}
